<ng-container *ngIf="formGroup; else loadingTpl">
  <h5 mat-dialog-title>{{ title }} Channel</h5>

  <div mat-dialog-content>
    <form [formGroup]="formGroup">
      <div class="row mt-2">
        <div class="col-12">
          <mat-form-field class="w-100">
            <mat-label>Channel Name</mat-label>
            <input
              aria-label="name"
              matInput
              stripSpaces
              formControlName="nameCtrl"
            />
            <span class="value small" *ngIf="nameCtrl?.valid">
              <ng-container *ngIf="loading; else valueTpl">
                <mat-progress-spinner
                  diameter="16"
                  mode="indeterminate"
                ></mat-progress-spinner>
              </ng-container>
              <ng-template #valueTpl>
                Value: <b><span [innerHTML]="value"></span></b>
              </ng-template>
            </span>
            <mat-error *ngIf="nameCtrl?.invalid">{{
              getErrorMsg(nameCtrl)
            }}</mat-error>
          </mat-form-field>

          <mat-form-field class="w-100">
            <mat-label>Label</mat-label>
            <input
              aria-label="label"
              matInput
              formControlName="labelCtrl"
              (change)="evaluateValidity()"
            />
            <mat-error *ngIf="labelCtrl?.invalid">{{
              getErrorMsg(labelCtrl)
            }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <mat-dialog-actions align="center">
    <button mat-flat-button mat-dialog-close color="warn">Cancel</button>
    <button
      mat-flat-button
      class="ml-2"
      color="primary"
      [disabled]="evaluateValidity()"
      (click)="save()"
    >
      Save
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-template #loadingTpl>
  <div class="text-center p-4">
    <mat-progress-spinner
      diameter="40"
      mode="indeterminate"
    ></mat-progress-spinner>
  </div>
</ng-template>
